import React from "react";
import { useFormContext } from "react-hook-form";
import { Info } from "react-feather";
import Input from "Components/UI/Input";

const PPEDetails = () => {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext();

  return (
    <>
      <div className="addproduct-icon list icon">
        <h5>
          <Info className="add-info" />
          <span>PPE Details</span>
        </h5>
      </div>

      <div className="row">
        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="ppeSize"
            type="text"
            placeholder=""
            className={`form-control ${
              errors.ppeSize ? "is-invalid" : ""
            }`}
            label="PPE Size"
            labelClassName="form-label"
            required={false}
            requiredMessage="PPE Size is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="shoeSize"
            type="text"
            placeholder=""
            className={`form-control ${
              errors.shoeSize ? "is-invalid" : ""
            }`}
            label="Shoe Size"
            labelClassName="form-label"
            required={false}
            requiredMessage="Shoe Size is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="ppeRemarks"
            type="text"
            placeholder=""
            className={`form-control ${
              errors.ppeRemarks ? "is-invalid" : ""
            }`}
            label="Remarks"
            labelClassName="form-label"
            required={false}
            requiredMessage="Remarks is required"
          />
        </div>
      </div>
    </>
  );
};

export default PPEDetails;
